module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('va-textarea', {
    attrs: {
      "rowCount": _vm.rowCount,
      "placeholder": _vm.placeholder,
      "isDisabled": _vm.isDisabled
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b02a05f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VATextareaGroup.vue
// module id = 515
// module chunks = 1